/**
 * Legacy `/tools/import` — retired by TNK-130 phase F. Kept as a thin
 * redirect to the staged-import wizard so any old bookmark, navbar
 * link, or operator muscle-memory still lands in the right place.
 *
 * The original one-shot importer (~1.2k lines) is preserved in git
 * history at the parent commit. None of its exports were imported
 * outside this file, so the deletion is contained.
 */
import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/tools/import")({
  component: LegacyImportRedirect,
});

function LegacyImportRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/tools/imports/new", replace: true });
  }, [navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Redirecting to the new import wizard…</p>
    </div>
  );
}
